import { Loading } from 'views/components/atoms/loading';
import { useGlobalLoading } from './hook';
import './style.scss';

export const GlobalLoading = () => {
  const { isShow, isCenter } = useGlobalLoading();

  if (!isShow) return;

  // サイドメニューがある場合に中央だと違和感があるので
  // adjustCenterでサイドメニューの幅だけ右にずらす
  return (
    <div className={`centerLoadingWrapper ${isCenter ? '' : 'adjustCenter'}`}>
      <Loading />
    </div>
  );
};
